<template>
  <div class="dj-schedule-page content">
    <div class="main-content-area">
      <section class="schedule-header text-center">
        <ResponsiveImage :image="bgPalm" :clamp="true" class="header-background-image" alt-text="DJ Schedule Header Image" />
        <div class="header-overlay">
          <div class="header-content">
            <h1 class="tulum-party-title-alt">DJ SCHEDULE</h1>
            <h2 class="subtitle">Tulum, Mexico</h2>
            <p class="tagline">tulum.party</p>

          </div>
        </div>
      </section>

      <div class="card">
        <p class="intro-text">
          <strong>Tulum</strong> is one of the biggest clusters of
          <router-link :to="{ path: '/djs' }">DJs and Artists</router-link>
          in all of the continent. Few places truly square up to Tulum in terms of its exclusivity and range of prolific high-profile DJs and Producers showing up in town
          <router-link :to="{ path: '/tulum-party-mexico-event-calendar' }">week by week</router-link>.
        </p>
      </div>
      <div class="highlight-section card">

        <h3 class="dj-schedule-section-title text-center">Hightlights</h3>
        <HotThisWeek align="text-center" :secondary-color="secondaryColor" />
      </div>

      <section class="full-schedule-section">
        <h3 class="sj-schedule-section-title text-center">Full Schedule</h3>
        <div
          v-for="(eventsInDate, date) in periodDates"
          :key="date"
          class="date-group"
        >
          <div class="date-header">
            <span class="month">{{ getMonthShort(date + 'T00:00') }}</span>
            <span class="day">{{ getDayNumeric(date + 'T00:00') }}</span>
            <span class="weekday">{{ getDay(date + 'T00:00') }}</span>
          </div>

          <div class="events-for-date">
            <div v-for="event in eventsInDate" :key="event.slug + event.title" class="event-entry">
              <ArtistCard
                :image="event.metadata && event.metadata.image_url"
                :show-content="true"
                :event="event"
                class="standard-artist-card"
              />
            </div>
          </div>
        </div>
        <div v-if="Object.keys(periodDates).length === 0 && !$store.state.status.loading" class="no-events">
          <p>No upcoming DJ events found in the schedule. Check back soon!</p>
        </div>
      </section>

      <div class="total-events-footer text-center">
        <small>Total Upcoming: {{ djSchedule.length }}</small>
      </div>

      <BrandCollection class="brand-collection-bottom" />
    </div>

    <aside class="sidebar-area card d-none d-lg-block">
      <SmartMenu
        :links="links"
        :logo="astroImg"
        ctaText="INFO"
        top-section-name="GET IN TOUCH"
        :primary-color="primaryColor"
      >
        <div class="sidebar-cta-text">
          <p>
            <strong>Do you need any recommendation</strong> based on your musical taste?
            <br />
            Drop us a line <br />we'll make you dance.
          </p>
          <hr />
        </div>
      </SmartMenu>
      <BrandCollection />
    </aside>
  </div>
</template>

<script>
import moment from 'moment';
// import MiniArtistCard from '@/components/Cards/MiniArtistCard'; // Not used in the provided template
import BrandCollection from '@/components/Cards/BrandCollection';
import SmartMenu from '@/components/SmartMenu/SmartMenu';
import HotThisWeek from '@/pages/TulumDjSchedule/HotThisWeek';
import ResponsiveImage from '@/components/HeadImage/ResponsiveImage';
import { eventDateMixin } from '@/common/eventDateMixin';
import ArtistCard from '@/components/Cards/ArtistCard'; // Corrected import

export default {
  name: 'DjSchedule',
  mixins: [eventDateMixin],
  components: {
    ArtistCard, // Corrected component name
    ResponsiveImage,
    HotThisWeek,
    BrandCollection,
    SmartMenu,
  },
  data: () => {
    return {
      bgPalm: "https://imgix.cosmicjs.com/0e9bd970-f811-11ec-b2b1-473235369c53-image.png",

      primaryColor: '#1C1C1F',
      secondaryColor: 'rgb(255, 141, 114)',
      astroImg: 'https://imgix.cosmicjs.com/1098dee0-e8ea-11ef-b333-e101bec29f3d-atro-transparent.png',
      djImage: 'https://imgix.cosmicjs.com/9f39a6a0-c70a-11ee-9ce5-59949019255e-dj.png', // Used in header
    };
  },
  metaInfo() {
    return {
      title: `Tulum DJ Schedule: Who's Playing When & Where`,
      meta: [
        {
          name: 'description',
          content: `Don't miss a beat! See the hottest DJs spinning in Tulum this week. Our Tulum DJ schedule shows you who's playing, when, and where.`
        },
        {
          name: 'keywords',
          content: `Tulum dj schedule, events, calendar, clubs, party agenda, dj agenda`
        },
        {
          property: 'og:title',
          content: `Don't Miss Out! Upcoming Tulum DJ Events`
        },
        {
          property: 'og:url',
          content: `https://www.tulum.party/tulum-dj-schedule`
        },
        {
          property: 'og:description',
          content: `Don't miss a beat! See the hottest DJs spinning in Tulum this week. Our Tulum DJ schedule shows you who's playing, when, and where.`
        },
        { property: 'og:type', content: 'website' }
      ]
    };
  },
  computed: {
    djSchedule() { // Renamed from computed property for clarity
      function isIncomingParty(x) {
        if (!x || !x.metadata || !x.metadata.date) return false; // Safety check
        let partyDateEndOfDay = moment.utc(x.metadata.date).endOf('day');
        let now = moment().startOf('day');
        return partyDateEndOfDay >= now;
      }

      return [...this.$store.state.djSchedule]
        .filter(event => event && event.metadata) // Ensure event and metadata exist
        .sort((a, b) => {
          let time_a = a.metadata.start_time || '00:00';
          let time_b = b.metadata.start_time || '00:00';
          return moment.utc(a.metadata.date + ' ' + time_a).valueOf() - moment.utc(b.metadata.date + ' ' + time_b).valueOf();
        })
        .filter(isIncomingParty);
    },
    links() { // Renamed from computed property
      return this.$store.state.links || [];
    },
    periodDates() { // Renamed from computed property
      let _periodDates = {};
      this.djSchedule.forEach((event) => {
        if (event && event.metadata && event.metadata.date) { // Safety check
          const dateKey = event.metadata.date;
          if (_periodDates[dateKey]) {
            _periodDates[dateKey].push(event);
          } else {
            _periodDates[dateKey] = [event];
          }
        }
      });
      return _periodDates;
    }
  },
  mounted() {
    moment.updateLocale('en', {
      week: {
        dow: 1 // Monday is the first day of the week.
      }
    });
    this.$store.dispatch('getDjSchedule'); // Removed .then as it wasn't used
    this.$store.dispatch('getLinks', { slug: 'tulum-dj-schedule' });
    // setTimeout(() => { // showPalms seems unused
    //   this.showPalms = true;
    // }, 3000);
  },
  methods: {
    googleCalendar() { // This method seems unused in the template
      if (window.ga) {
        window.ga('send', 'event', 'Event', 'Calendar', 'Google Calendar', 1);
      }
      if (this.$rollbar) {
        this.$rollbar.info(`Google Calendar Open`);
      }
    }
  }
};
</script>

